/* ============================================================
   NORTHSHEEP — Favorites
   localStorage-backed "save for later". Heart buttons (product page +
   cards) feed a header count, a cart-like drawer, and a dedicated
   favorites page that renders the SAME card as the collection grid,
   with click/hold-drag manual reorder.
   No libraries. Safe without localStorage. The only product request is the
   small status check (ns-product-status.js) that drops sold / removed
   favourites, and it runs only on the favourites page and when the drawer
   opens — never on every page.
   ============================================================ */
(function () {
  'use strict';

  // Shopify prefixes every URL with the locale root on multi-language stores.
  function nsRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  if (window.__nsFavoritesLoaded) return;
  window.__nsFavoritesLoaded = true;

  var KEY = 'northsheep_favorite_products';

  var SVG_BIN = '<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-remove" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path fill="currentColor" d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1M6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02m4.84 11.52h-7.5V4h7.5z"/><path fill="currentColor" d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5"/></svg>';
  var SVG_HEART = '<svg class="ns-fav-heart" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M12 20.3l-1.45-1.32C5.4 14.36 2 11.28 2 7.78 2 4.92 4.2 2.7 7 2.7c1.74 0 3.4.86 4.45 2.23l.55.72.55-.72A5.5 5.5 0 0 1 17 2.7c2.8 0 5 2.22 5 5.08 0 3.5-3.4 6.58-8.55 11.2L12 20.3z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>';

  function lsOk() {
    try { localStorage.setItem('__nsf_test__', '1'); localStorage.removeItem('__nsf_test__'); return true; }
    catch (e) { return false; }
  }
  var LS = lsOk();

  /* Parsed once, not per call. NsFavorites.has() runs for every card on every
     filter pass, and each call used to do a synchronous localStorage read and
     a JSON.parse of the whole list. The cache is dropped on every write below
     and on the `storage` event (another tab changed the list), so a read
     always sees what a fresh parse would. read() hands out a copy, because
     callers sort or push into the array they get back. */
  var listCache = null;
  function cached() {
    if (listCache) return listCache;
    try {
      var r = localStorage.getItem(KEY);
      var a = r ? JSON.parse(r) : [];
      listCache = Array.isArray(a) ? a.filter(function (p) { return p && p.handle; }) : [];
    } catch (e) { return []; }
    return listCache;
  }
  function read() {
    if (!LS) return [];
    return cached().slice();
  }
  function write(a) {
    if (!LS) return;
    listCache = null;
    try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {}
  }
  window.addEventListener('storage', function (e) {
    if (e.key === KEY || e.key === null) listCache = null;
  });
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function idxOf(list, h) {
    for (var i = 0; i < list.length; i++) if (list[i].handle === h) return i;
    return -1;
  }

  // ---- config (from the global root element) ----
  var cfg = null;

  /* ---- Sold / removed favourites (2026-09-16) ----
     Deleted or unpublished products ('gone') are removed from the list for
     good: they would only be dead links, and the Flow deletes sold unique
     hides after 60 days. Sold-out ones stay saved — a random sheepskin or a
     blanket comes back — but are hidden while Theme settings → "Hide sold-out
     products in favourites" is on; otherwise they keep their Sold out label.
     The header count, the drawer and the page all count only what is shown. */
  function hideSold() {
    return !!(window.NsProductStatus && window.NsProductStatus.hideSoldOut());
  }
  function visible(list) {
    if (!hideSold()) return list;
    return list.filter(function (p) { return p.available !== false; });
  }
  var pruning = false;
  function pruneFavorites(done) {
    var api = window.NsProductStatus;
    if (!api || pruning || !LS) return;
    var handles = read().map(function (p) { return p.handle; });
    if (!handles.length) return;
    pruning = true;
    api.check(handles).then(function (res) {
      pruning = false;
      var changed = false;
      var next = read().filter(function (p) {
        var s = res[p.handle];
        if (s === 'gone') { changed = true; return false; }
        if (s === 'ok' && p.available === false) { p.available = true; changed = true; }
        if (s === 'soldout' && p.available !== false) { p.available = false; changed = true; }
        return true;
      });
      // Only a real change re-renders, so the re-render's own check (answered
      // from the 15-minute cache) finds nothing and the loop ends there.
      if (changed) { write(next); if (done) done(); }
    }, function () { pruning = false; });
  }

  function getCfg() {
    if (cfg) return cfg;
    var root = document.querySelector('[data-ns-fav-root]');
    var g = function (n, d) { return root && root.getAttribute(n) != null ? root.getAttribute(n) : d; };
    cfg = {
      addedLabel: g('data-added-label', 'Saved'),
      defaultLabel: g('data-default-label', 'Save'),
      pageUrl: g('data-page-url', '/pages/favorites'),
      ctaText: g('data-cta-text', 'View favorites'),
      emptyText: g('data-empty-text', 'No favorites added yet.'),
      addedToast: g('data-added-toast', 'Saved to favorites'),
      cartToast: g('data-cart-toast', 'Added to basket'),
      soldOut: g('data-soldout', 'Sold out'),
      inStock: g('data-instock', 'In stock'),
      viewText: g('data-view-text', 'View product'),
      addToCart: g('data-atc-text', 'Add to cart'),
      chooseOptions: g('data-choose-text', 'Choose options'),
      reorderDemo: g('data-reorder-demo', 'true') !== 'false',
      reorderHint: g('data-reorder-hint', 'Hold and drag a card to reorder'),
      removeText: g('data-remove-text', 'Remove __T__'),
      /* The basket errors, in the store's language (English on all five stores
         until the audit of 2 Oct 2026). */
      addError: g('data-add-error', 'Could not add some items.'),
      errorText: g('data-error-text', 'Something went wrong. Please try again.'),
      /* The heart's label for screen readers, in the store's language (it was
         English on all five stores; proofread, 25 Sep 2026). */
      addAria: g('data-add-aria', 'Add to favourites: __T__'),
      removeAria: g('data-remove-aria', 'Remove from favourites: __T__')
    };
    return cfg;
  }

  function dataFromBtn(btn) {
    return {
      handle: btn.getAttribute('data-product-handle'),
      title: btn.getAttribute('data-product-title'),
      url: btn.getAttribute('data-product-url'),
      image: btn.getAttribute('data-product-image'),
      price: btn.getAttribute('data-product-price'),
      vendor: btn.getAttribute('data-product-vendor'),
      available: btn.getAttribute('data-product-available') !== 'false',
      variant_id: btn.getAttribute('data-product-variant-id') || '',
      variants_count: parseInt(btn.getAttribute('data-product-variants-count'), 10) || 0,
      ratio: parseFloat(btn.getAttribute('data-product-ratio')) || 0,
      timestamp: Date.now()
    };
  }

  // add-to-cart (single variant) via Dawn's cart drawer/notification
  /* ONE REQUEST PER ITEM AT A TIME, AND SAY THAT THE CART CHANGED (audit,
     23 Sep 2026). Measured on the favourites page: a double tap sent two
     adds (the second, for a one-of-a-kind hide, refused in silence), and a
     sheepskin added here never brought its free brush — the gift script, like
     everything else, learns about adds from PUB_SUB_EVENTS.cartUpdate, and
     this bare fetch never published it. Added from the product page, the
     same hide did bring it. No cartData: /cart/add answers with the LINE
     ITEM, not the cart (see announce() in ns-cart-upsells.js). */
  var addsInFlight = {};
  function addToCart(variantId, btn) {
    if (!variantId || addsInFlight[variantId]) return;
    addsInFlight[variantId] = true;
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    var config;
    try { config = fetchConfig('javascript'); } catch (e) { config = { method: 'POST', headers: {} }; }
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    config.body = fd;
    if (btn) btn.classList.add('is-loading');
    fetch(url, config)
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        if (resp && resp.status) {
          // Refused (e.g. the only one is already in the basket): say why,
          // as "add all" below already does, instead of doing nothing.
          toast(resp.description || resp.message);
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          try {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ns-favorites', productVariantId: String(variantId) });
          } catch (e) {}
        }
        if (cart && typeof cart.renderContents === 'function') {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(resp);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {})
      .finally(function () {
        delete addsInFlight[variantId];
        if (btn) btn.classList.remove('is-loading');
      });
  }

  // ---- "Add all to cart": add every available favourite to the cart in one
  // request, then open the cart drawer (no auto-checkout — the shopper decides).
  // Items with a known variant_id and not explicitly sold out are included
  // (single/default variant). ----
  function addAllToCart(btn) {
    var list = read();
    var items = [];
    var seen = {};
    for (var i = 0; i < list.length; i++) {
      var p = list[i];
      var vid = p && p.variant_id;
      if (!vid) continue;
      if (p.available === false) continue;
      if (seen[vid]) continue;
      seen[vid] = 1;
      items.push({ id: vid, quantity: 1 });
    }
    if (!items.length) { toast(getCfg().emptyText); return; }
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    // ensure the .js endpoint so we get JSON back
    if (url.indexOf('.js') === -1) url = url.replace(/\/?$/, '') + '.js';
    var body = { items: items };
    // ask Shopify to also render the cart drawer/notification sections so we can
    // refresh + open it (same handshake Dawn's product form uses).
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    var done = function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); btn.disabled = false; } };
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        done();
        if (!res.ok || (res.body && res.body.status)) {
          toast((res.body && res.body.description) || getCfg().addError);
          /* Shopify keeps the lines added before the one it refused (a sold-out
             favourite): announce the change anyway, so the drawer redraws itself
             and the free brush follows a sheepskin that did go in (4 Oct 2026
             audit). No cartData, as below. */
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            try {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ns-favorites' });
            } catch (e) {}
          }
          return;
        }
        /* Announced like any other add — see addToCart above. No cartData:
           this answer lists only the lines just added, and a listener would
           take that for the whole basket. */
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          try {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ns-favorites' });
          } catch (e) {}
        }
        if (cart && typeof cart.renderContents === 'function') {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          // renderContents() refreshes the drawer sections AND opens it (Dawn).
          cart.renderContents(res.body);
        } else {
          toast(getCfg().cartToast);
        }
      })
      .catch(function () {
        done();
        toast(getCfg().errorText);
      });
  }

  // ---- mutations (NO max limit) ----
  function add(d) {
    if (!d || !d.handle) return false;
    var list = read();
    if (idxOf(list, d.handle) >= 0) return true; // no dupes
    list.push(d);
    write(list);
    return true;
  }
  function remove(h) { write(read().filter(function (p) { return p.handle !== h; })); }
  function clearAll() { write([]); }

  // ---- toast ----
  var toastEl = null, toastTimer = null;
  function toast(msg, dur) {
    if (!msg) return;
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ns-fav-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, dur || 2600);
  }

  /* ---- saving something says so on the card, not in a bar ----
     Owner, 20 Sep 2026: "remove the 'saved to favourites' nobody is waiting
     for that message everytime they can see also on the top right that the
     heart is red so confirmed they dont need a confirmation everytime".

     He is right, and it was worse than redundant: the pill sat bottom-centre
     for 2.6 seconds, which is where the thumb is, and someone saving five
     hides in a row had it on screen permanently. The heart under their finger
     turning red already says it, and a gesture now leaves a heart stamped on
     the photo as well (ns-collection-curate.js).

     THE WORDS STAY FOR ANYONE WHO CANNOT SEE THE HEART. A red heart is not an
     announcement to a screen reader, so the same sentence still goes to a
     live region — it is simply never painted. Removing the text altogether
     would have left those shoppers with silence where everyone else gets a
     confirmation. The visible toast is untouched everywhere it still carries
     something nothing else says: errors, the add-all-to-cart result, the
     reorder hint. */
  /* ============================================================
     THE PRODUCT PAGE'S HEART FOLLOWS THE CHOSEN SIZE

     Owner, 20 Sep 2026: "can you make sure its the correct/selected variant
     that is saved".

     Liquid puts the selected variant on the button when the page is rendered,
     which is right until the shopper picks a different size. Dawn re-renders
     the price and the buy buttons then, but the heart sits outside that block
     and kept the size the page opened on — so choosing XL and saving stored
     the M.

     Dawn announces the change by setting the hidden id input and firing a
     bubbling `change` on it, which is the one signal that exists whatever the
     picker looks like — pills, dropdown or swatches. The price is read back
     from the page rather than formatted here: Dawn has already written the
     money in the shop's own format, including a sale price, and reading it is
     both simpler and impossible to get wrong in a currency this file does not
     know about.
     ============================================================ */
  /* Dawn publishes the CHOSEN variant as a single JSON object inside
     variant-selects — not the whole variants array, which is what this looked
     for at first and never found. It is re-rendered with the price, so when
     its id matches the one in the form, the rest of the page has caught up
     too. That makes it a signal to wait for rather than a delay to guess. */
  function selectedVariantJson() {
    var el = document.querySelector('variant-selects [type="application/json"], [data-selected-variant]');
    if (!el) return null;
    try {
      var v = JSON.parse(el.textContent);
      return v && v.id ? v : null;
    } catch (e) {
      return null;
    }
  }

  /* SCOPED TO THE PRODUCT'S OWN PRICE, and that is not a detail: a comma in
     the selector made this read the first `.price` in the document, which on
     this theme is a line in the cart drawer. The heart was being given the
     price of something already in the basket. */
  function shownPrice() {
    var box = document.querySelector('.product__info-container .price');
    if (!box) return null;
    var onSale = box.classList.contains('price--on-sale');
    var el = box.querySelector(onSale ? '.price-item--sale' : '.price-item--regular');
    var txt = el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
    return txt || null;
  }

  function syncProductButton(id, tries) {
    var btn = document.querySelector('.ns-favorite-button[data-ns-fav-btn]');
    if (!btn || !id) return;
    var v = selectedVariantJson();
    /* Wait for the page to finish changing its mind. Up to about a second and
       a half; after that, whatever is on the page is what gets saved. */
    if ((!v || String(v.id) !== String(id)) && (tries || 0) < 12) {
      setTimeout(function () {
        syncProductButton(id, (tries || 0) + 1);
      }, 120);
      return;
    }
    var was = btn.getAttribute('data-product-variant-id');
    btn.setAttribute('data-product-variant-id', id);

    var base = (btn.getAttribute('data-product-url') || '').split('?')[0];
    btn.setAttribute('data-product-url', base + '?variant=' + id);

    var price = shownPrice();
    if (price) btn.setAttribute('data-product-price', price);

    if (v) {
      if (v.title && v.title !== 'Default Title') {
        btn.setAttribute('data-product-variant-title', v.title);
        btn.setAttribute('data-product-vendor', v.title);
      }
      btn.setAttribute('data-product-available', v.available ? 'true' : 'false');
      if (v.featured_image && v.featured_image.src) btn.setAttribute('data-product-image', v.featured_image.src);
    }

    /* A size already saved keeps its own entry; changing size on the page does
       not quietly rewrite what is in the favourites. But the heart itself has
       to tell the truth about the size now showing, which is a different
       question from the one it answered a moment ago. */
    if (was !== String(id)) syncButtons();
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.name !== 'id') return;
    syncProductButton(t.value, 0);
  });

  /* THE PRICE IS WATCHED, NOT TIMED.

     Reading it once when the variant json caught up was always a step behind:
     Dawn updates that json from data it already has, and re-renders the price
     from the server a moment later, so the "matching" moment still held the
     previous size's money. A poll tight enough to catch the difference is a
     poll running for no reason on every product page.

     So the price block is simply watched. Whenever Dawn writes a new price,
     the heart takes it — whatever order the rest of the page updates in, and
     however slow the connection is. */
  (function watchPrice() {
    var watching = null;
    function start() {
      if (watching) watching.disconnect();
      watching = null;
      var info = document.querySelector('.product__info-container');
      var btn = document.querySelector('.ns-favorite-button[data-ns-fav-btn]');
      if (!info || !btn || !window.MutationObserver) return;
      var timer = 0;
      var apply = function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var p = shownPrice();
          if (p) btn.setAttribute('data-product-price', p);
        }, 60);
      };
      watching = new MutationObserver(apply);
      watching.observe(info, { childList: true, subtree: true, characterData: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    /* A colour swap replaces the price block and the heart with the new
       page's (audit, 4 Oct 2026, S7): the watch moves to those, or a size
       picked after the swap was saved with the size before's price. */
    document.addEventListener('ns:colour-swapped', start);
  })();

  /* ON A PHONE, THE HEADER ANSWERS (owner, 20 Sep 2026). Saving a piece brings
     the floating header down for a moment and counts the favourites bubble up,
     so the shopper sees where it went and is one tap from the drawer — instead
     of a message that says the same thing and then has to be dismissed.

     Silent on a desktop, where the header does not float and the heart under
     the cursor has already answered. */
  function flashHeader() {
    if (window.NsFloatHeader && NsFloatHeader.flash) NsFloatHeader.flash('fav');
  }

  var liveEl = null;
  function announce(msg) {
    if (!msg) return;
    if (!liveEl) {
      liveEl = document.createElement('div');
      liveEl.className = 'visually-hidden';
      liveEl.setAttribute('role', 'status');
      liveEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(liveEl);
    }
    /* Cleared first: a live region whose text does not CHANGE is not
       re-announced, so saving a second product in a row would be silent. */
    liveEl.textContent = '';
    setTimeout(function () { liveEl.textContent = msg; }, 60);
  }

  // ---- sync: buttons + header count ----
  function syncButtons() {
    var list = read(), set = {};
    list.forEach(function (p) { set[p.handle] = true; });
    var c = getCfg();
    var btns = document.querySelectorAll('[data-ns-fav-btn]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i], h = b.getAttribute('data-product-handle'), active = !!set[h];
      b.classList.toggle('is-favorite', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
      var lbl = b.querySelector('[data-ns-fav-label]');
      if (lbl) lbl.textContent = active ? c.addedLabel : c.defaultLabel;
      var title = b.getAttribute('data-product-title') || '';
      b.setAttribute('aria-label', (active ? c.removeAria : c.addAria).replace('__T__', title));
    }
  }
  function syncCount() {
    var n = visible(read()).length;
    var els = document.querySelectorAll('[data-ns-fav-count]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var span = el.querySelector('span[aria-hidden="true"]') || el.querySelector('span') || el;
      if (n > 0) { el.hidden = false; el.removeAttribute('hidden'); if (span) span.textContent = n; }
      else { el.hidden = true; el.setAttribute('hidden', ''); }
    }
  }

  // ---- drawer ----
  function drawerEl() { return document.querySelector('[data-ns-fav-drawer]'); }
  function isDrawerOpen() { var d = drawerEl(); return !!(d && d.classList.contains('is-open')); }
  function drawerItemHtml(p) {
    var url = p.url || '/products/' + (p.handle || '');
    var img = p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title || '') + '" loading="lazy">' : '';
    var vendor = p.vendor ? '<p class="ns-fav-item__vendor">' + esc(p.vendor) + '</p>' : '';
    var price = p.price ? '<span class="ns-fav-item__price">' + esc(p.price) + '</span>' : '';
    return (
      '<div class="ns-fav-item">' +
      '<a class="ns-fav-item__media" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
      '<div class="ns-fav-item__info">' +
      '<p class="ns-fav-item__title"><a href="' + esc(url) + '">' + esc(p.title || '') + '</a></p>' +
      vendor + price +
      '</div>' +
      '<button type="button" class="ns-fav-item__remove" data-ns-fav-remove="' + esc(p.handle) +
      '" aria-label="' + esc(getCfg().removeText.replace('__T__', p.title || '')) + '">' + SVG_BIN + '</button>' +
      '</div>'
    );
  }
  function renderDrawer() {
    var d = drawerEl();
    if (!d) return;
    var list = visible(read()), c = getCfg();
    var body = d.querySelector('[data-ns-fav-drawer-body]');
    var foot = d.querySelector('[data-ns-fav-drawer-foot]');
    var cta = d.querySelector('[data-ns-fav-cta]');
    var tip = d.querySelector('[data-ns-fav-tip]');
    if (!body) return;
    // "Compare side by side on the page" - only worth saying from two up.
    if (tip) tip.hidden = list.length < 2;
    if (list.length === 0) {
      /* What favourites are for, printed by ns-favorites-drawer.liquid (owner,
         2 Oct 2026); the one plain line stays as the fallback. */
      var emptyTpl = d.querySelector('template[data-ns-fav-empty-tpl]');
      if (emptyTpl && emptyTpl.content) {
        body.innerHTML = '';
        body.appendChild(emptyTpl.content.cloneNode(true));
      } else {
        body.innerHTML = '<p class="ns-fav-drawer__empty">' + esc(c.emptyText) + '</p>';
      }
      if (foot) foot.hidden = true;
      return;
    }
    var html = '';
    for (var i = 0; i < list.length; i++) html += drawerItemHtml(list[i]);
    body.innerHTML = html;
    if (foot) foot.hidden = false;
    if (cta) { cta.textContent = c.ctaText; cta.setAttribute('href', c.pageUrl); }
  }
  /* FOCUS GOES BACK WHERE IT CAME FROM (audit, 23 Sep 2026). The drawer
     took focus when it opened but never gave it back: after Escape or the
     close button, focus sat on the hidden panel. Now it returns to whatever
     opened the drawer — only if it is still inside the drawer, so a tap
     elsewhere that closed it keeps its own focus. preventScroll: the opener
     is usually the header's heart, far above a scrolled page. */
  var drawerOpener = null;
  function openDrawer() {
    var d = drawerEl();
    if (!d) return;
    var active = document.activeElement;
    drawerOpener = active && active !== document.body && !d.contains(active) ? active : null;
    renderDrawer();
    pruneFavorites(syncAll);
    d.classList.add('is-open');
    document.body.classList.add('ns-fav-open');
    var panel = d.querySelector('.ns-fav-drawer__panel');
    if (panel) { try { panel.focus(); } catch (e) {} }
  }
  function closeDrawer() {
    var d = drawerEl();
    if (!d) return;
    var back = drawerOpener;
    drawerOpener = null;
    var focusWasInside = d.contains(document.activeElement);
    d.classList.remove('is-open');
    document.body.classList.remove('ns-fav-open');
    if (focusWasInside && back && back.isConnected) {
      try { back.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  // ---- favorites page: renders the SAME card markup as the collection grid
  // (styled by northsheep-collection.css, scoped via .ns-fav-collection) ----
  function pageCardHtml(p, c) {
    var url = p.url || '/products/' + (p.handle || '');
    var ratio = p.ratio && p.ratio > 0 ? p.ratio : 0.8;
    var ratioPct = (100 / ratio).toFixed(2);
    var ratioAuto = p.ratio && p.ratio > 0 ? '' : ' data-ns-fav-ratio-auto';
    var img = p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title || '') + '" loading="lazy">' : '';
    var soldout = p.available === false;
    var single = (p.variants_count || 1) <= 1;

    // Match the collection card: over-image ATC only for single-variant
    // products (multi-variant cards show no button — the card opens the PDP).
    var atcDesktop = '', atcMobile = '';
    if (single) {
      var atcInner = soldout
        ? '<button type="button" class="ns-card-atc__btn" disabled aria-disabled="true"><span>' + esc(c.soldOut) + '</span></button>'
        : '<button type="button" class="ns-card-atc__btn" data-ns-fav-atc="' + esc(p.variant_id) + '"><span>' + esc(c.addToCart) + '</span></button>';
      atcDesktop = '<div class="ns-card-atc ns-card-atc--desktop">' + atcInner + '</div>';
      atcMobile = '<div class="ns-card-atc ns-card-atc--mobile">' + atcInner + '</div>';
    }
    var badge = soldout
      ? '<div class="card__content"><div class="card__badge"><span class="badge badge--bottom-left">' + esc(c.soldOut) + '</span></div></div>'
      : '';
    var vendor = p.vendor ? '<div class="caption-with-letter-spacing light">' + esc(p.vendor) + '</div>' : '';
    var price = p.price ? '<div class="price"><span class="price-item price-item--regular">' + esc(p.price) + '</span></div>' : '';

    return (
      '<li class="grid__item" data-ns-fav-card="' + esc(p.handle) + '">' +
      '<div class="card-wrapper product-card-wrapper">' +
      '<div class="card card--standard card--media">' +
      '<div class="card__inner ratio"' + ratioAuto + ' style="--ratio-percent:' + ratioPct + '%;">' +
      '<div class="card__media">' +
      '<div class="media media--transparent media--hover-effect">' +
      '<a href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
      '</div>' +
      '</div>' +
      '<button type="button" class="ns-card-favorite-button is-favorite" data-ns-fav-remove="' + esc(p.handle) +
      '" aria-label="' + esc(getCfg().removeAria.replace('__T__', p.title || '')) + '">' + SVG_HEART + '</button>' +
      atcDesktop +
      badge +
      '</div>' +
      '<div class="card__content">' +
      '<div class="card__information">' +
      '<h3 class="card__heading h5"><a class="full-unstyled-link" href="' + esc(url) + '">' + esc(p.title || '') + '</a></h3>' +
      '<div class="card-information">' + vendor + price + atcMobile + '</div>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</li>'
    );
  }

  // For favorites saved before ratios were stored, snap the card box to the
  // image's real aspect ratio once it loads (so it matches the adapt grid).
  function refineRatios(grid) {
    var autos = grid.querySelectorAll('[data-ns-fav-ratio-auto]');
    for (var i = 0; i < autos.length; i++) {
      (function (inner) {
        var im = inner.querySelector('img');
        if (!im) return;
        var set = function () {
          if (im.naturalWidth && im.naturalHeight) {
            inner.style.setProperty('--ratio-percent', ((im.naturalHeight / im.naturalWidth) * 100).toFixed(2) + '%');
          }
        };
        if (im.complete) set();
        else im.addEventListener('load', set, { once: true });
      })(autos[i]);
    }
  }

  /* Availability used to be re-checked here with one full /products/x.js per
     card, and a deleted product (404) was silently skipped — its card stayed,
     linking nowhere. pruneFavorites() above replaces it: the sold-out label
     now comes from the stored flag it keeps up to date (pageCardHtml renders
     it), and the locale-root lesson from that code lives on in
     ns-product-status.js. */

  // First-visit reorder demo: the first card lifts and swaps places with the
  // second, then settles back — a one-time, reduced-motion-aware hint that
  // cards can be dragged to reorder.
  var demoRan = false;
  function demoReorder(grid, c) {
    var cards = grid.querySelectorAll('[data-ns-fav-card]');
    if (cards.length < 2) return;
    var a = cards[0], b = cards[1];
    var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect();
    var dx = rb.left - ra.left, dy = rb.top - ra.top;
    var easing = 'transform 760ms cubic-bezier(0.22, 0.61, 0.36, 1)';
    toast(c.reorderHint, 5200);
    a.classList.add('ns-fav-demo');
    setTimeout(function () {
      a.style.transition = easing;
      b.style.transition = easing;
      a.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
      b.style.transform = 'translate(' + -dx + 'px,' + -dy + 'px)';
    }, 650);
    setTimeout(function () {
      a.style.transform = 'translate(0px,0px)';
      b.style.transform = 'translate(0px,0px)';
    }, 2300);
    setTimeout(function () {
      a.classList.remove('ns-fav-demo');
      a.style.transition = ''; b.style.transition = '';
      a.style.transform = ''; b.style.transform = '';
    }, 3300);
  }
  function maybeDemo(grid, n) {
    if (demoRan || n < 2) return;
    var c = getCfg();
    if (!c.reorderDemo) return;
    // Add ?fav-demo=1 to the URL to force-replay the demo on every load
    // (for testing/judging) — it bypasses the once-per-visitor flag.
    var force = location.search.indexOf('fav-demo') !== -1;
    if (!force) {
      var seen = false;
      try { seen = localStorage.getItem('northsheep_fav_reorder_seen') === '1'; } catch (e) {}
      if (seen) return;
    }
    demoRan = true;
    if (!force) { try { localStorage.setItem('northsheep_fav_reorder_seen', '1'); } catch (e) {} }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce && !force) { toast(c.reorderHint); return; }
    setTimeout(function () { demoReorder(grid, c); }, 800);
  }

  function renderPage() {
    var grid = document.querySelector('[data-ns-fav-page-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-ns-fav-page-empty]');
    var toolbar = document.querySelector('[data-ns-fav-toolbar]');
    var foot = document.querySelector('[data-ns-fav-foot]');
    var list = visible(read()), c = getCfg();
    if (list.length === 0) {
      grid.innerHTML = '';
      grid.hidden = true;
      if (empty) empty.hidden = false;
      if (toolbar) toolbar.hidden = true;
      if (foot) foot.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    grid.hidden = false;
    if (toolbar) toolbar.hidden = false;
    // The "Check out all" button only makes sense if at least one favourite is
    // purchasable (has a known variant and isn't sold out).
    if (foot) {
      var anyBuyable = false;
      for (var k = 0; k < list.length; k++) {
        if (list[k] && list[k].variant_id && list[k].available !== false) { anyBuyable = true; break; }
      }
      foot.hidden = !anyBuyable;
    }
    var html = '';
    for (var i = 0; i < list.length; i++) html += pageCardHtml(list[i], c);
    grid.innerHTML = html;
    refineRatios(grid);
    setupSort(grid);
    pruneFavorites(syncAll);
    maybeDemo(grid, list.length);
  }

  // ---- reorder: the grabbed card LIFTS (fixed-position) and follows the
  // finger/cursor; a placeholder holds its slot and the other cards FLIP into
  // place. Desktop = press-drag; touch = hold-drag. A real click navigates;
  // a drag is suppressed. ----
  function setupSort(grid) {
    if (grid.dataset.nsSort === '1') return;
    grid.dataset.nsSort = '1';
    var drag = null, ph = null, hold = null, started = false, didDrag = false;
    var sx = 0, sy = 0, cx = 0, cy = 0, offX = 0, offY = 0, w = 0, h = 0, touch = false;
    var scrollRAF = null, scrollDir = 0;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function commit() {
      var order = [];
      grid.querySelectorAll('[data-ns-fav-card]').forEach(function (c) { order.push(c.getAttribute('data-ns-fav-card')); });
      var list = read();
      list.sort(function (a, b) { return order.indexOf(a.handle) - order.indexOf(b.handle); });
      write(list);
    }
    function flipOthers(fn) {
      var els = [];
      grid.querySelectorAll('[data-ns-fav-card]').forEach(function (e) { if (e !== drag) els.push(e); });
      if (reduce) { fn(); return; }
      var first = els.map(function (el) { return el.getBoundingClientRect(); });
      fn();
      els.forEach(function (el, i) {
        var last = el.getBoundingClientRect();
        var dx = first[i].left - last.left, dy = first[i].top - last.top;
        if (dx || dy) {
          el.style.transition = 'none';
          el.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
          requestAnimationFrame(function () {
            el.style.transition = 'transform 200ms ease';
            el.style.transform = '';
          });
        }
      });
    }
    function moveGhost() {
      drag.style.left = cx - offX + 'px';
      drag.style.top = cy - offY + 'px';
    }
    function start() {
      started = true; didDrag = true;
      var rect = drag.getBoundingClientRect();
      w = rect.width; h = rect.height;
      offX = cx - rect.left; offY = cy - rect.top;
      ph = document.createElement('li');
      ph.className = 'grid__item ns-fav-placeholder';
      ph.style.height = h + 'px';
      drag.parentNode.insertBefore(ph, drag);
      drag.classList.add('ns-fav-dragging');
      drag.style.position = 'fixed';
      drag.style.zIndex = '999';
      drag.style.width = w + 'px';
      drag.style.height = h + 'px';
      drag.style.margin = '0';
      document.body.classList.add('ns-fav-sorting');
      moveGhost();
    }
    function reorder() {
      var prev = drag.style.pointerEvents;
      drag.style.pointerEvents = 'none';
      var under = document.elementFromPoint(cx, cy);
      drag.style.pointerEvents = prev;
      var target = under && under.closest ? under.closest('[data-ns-fav-card]') : null;
      if (!target || target === drag || target.parentNode !== grid) return;
      var rect = target.getBoundingClientRect();
      var before = cx < rect.left + rect.width / 2;
      flipOthers(function () {
        if (before) grid.insertBefore(ph, target);
        else grid.insertBefore(ph, target.nextSibling);
      });
    }
    // Auto-scroll the page while the lifted card is held near the top/bottom
    // edge, so you can drag a card far up or down a long list.
    function tickScroll() {
      if (!started || !scrollDir) { scrollRAF = null; return; }
      var before = window.pageYOffset;
      window.scrollBy(0, scrollDir);
      if (window.pageYOffset !== before) reorder();
      scrollRAF = requestAnimationFrame(tickScroll);
    }
    function autoScroll() {
      var edge = 90, vh = window.innerHeight, sp = 0;
      if (cy < edge) sp = -Math.max(2, Math.ceil((edge - cy) / 6));
      else if (cy > vh - edge) sp = Math.max(2, Math.ceil((cy - (vh - edge)) / 6));
      scrollDir = sp;
      if (sp && scrollRAF == null) scrollRAF = requestAnimationFrame(tickScroll);
    }
    function end() {
      if (scrollRAF != null) { cancelAnimationFrame(scrollRAF); scrollRAF = null; }
      scrollDir = 0;
      if (started) {
        if (ph && ph.parentNode) {
          ph.parentNode.insertBefore(drag, ph);
          ph.parentNode.removeChild(ph);
        }
        drag.classList.remove('ns-fav-dragging');
        drag.style.position = ''; drag.style.zIndex = ''; drag.style.width = '';
        drag.style.height = ''; drag.style.margin = ''; drag.style.left = ''; drag.style.top = '';
        commit();
      }
      document.body.classList.remove('ns-fav-sorting');
      started = false; drag = null; ph = null;
      clearTimeout(hold);
      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('touchmove', onTouchMove);
      document.removeEventListener('pointerup', onUp);
      document.removeEventListener('pointercancel', onUp);
    }
    function onMove(e) {
      cx = e.clientX; cy = e.clientY;
      if (!drag) return;
      if (!started) {
        var dd = Math.abs(cx - sx) + Math.abs(cy - sy);
        if (touch) { if (dd > 12) { clearTimeout(hold); end(); } return; }
        if (dd > 6) start(); else return;
      }
      e.preventDefault();
      moveGhost();
      reorder();
      autoScroll();
    }
    function onUp() { end(); }
    // Pointer-event preventDefault does NOT stop touch scrolling — only a
    // non-passive touchmove does. Block native scroll while a card is lifted
    // (auto-scroll moves the page instead), so the drag can't be torn away.
    function onTouchMove(e) { if (started) e.preventDefault(); }

    // Kill native image/link drag + the touch long-press callout that would
    // otherwise hijack the gesture (e.g. "copy link" on mobile).
    grid.addEventListener('dragstart', function (e) { e.preventDefault(); });
    grid.addEventListener('contextmenu', function (e) { if (touch) e.preventDefault(); });

    grid.addEventListener('pointerdown', function (e) {
      if (e.button != null && e.button !== 0) return;
      var card = e.target.closest('[data-ns-fav-card]');
      if (!card) return;
      didDrag = false;
      if (e.target.closest('button')) return; // heart + ATC buttons click normally
      drag = card; sx = cx = e.clientX; sy = cy = e.clientY; started = false;
      touch = e.pointerType === 'touch';
      if (touch) hold = setTimeout(start, 300);
      document.addEventListener('pointermove', onMove, { passive: false });
      document.addEventListener('touchmove', onTouchMove, { passive: false });
      document.addEventListener('pointerup', onUp);
      document.addEventListener('pointercancel', onUp);
    });

    // Suppress the click that follows a drag so the card link doesn't navigate.
    grid.addEventListener('click', function (e) {
      if (didDrag) { e.preventDefault(); e.stopPropagation(); didDrag = false; }
    }, true);
  }

  function syncAll() {
    syncButtons();
    syncCount();
    if (isDrawerOpen()) renderDrawer();
    renderPage();
  }

  // ---- events (delegated) ----
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var btn = t.closest('[data-ns-fav-btn]');
    if (btn) {
      e.preventDefault();
      var d = dataFromBtn(btn);
      if (idxOf(read(), d.handle) >= 0) { remove(d.handle); syncAll(); }
      else if (add(d)) { syncAll(); announce(getCfg().addedToast); flashHeader(); }
      return;
    }
    if (t.closest('[data-ns-fav-toggle]')) { e.preventDefault(); isDrawerOpen() ? closeDrawer() : openDrawer(); return; }
    if (t.closest('[data-ns-fav-close]')) { e.preventDefault(); closeDrawer(); return; }
    if (t.closest('[data-ns-fav-overlay]')) { closeDrawer(); return; }
    var inDrawer = t.closest('[data-ns-fav-drawer]');
    if (inDrawer && inDrawer.classList.contains('is-open') && !t.closest('.ns-fav-drawer__panel')) { closeDrawer(); return; }

    var rm = t.closest('[data-ns-fav-remove]');
    if (rm) { e.preventDefault(); remove(rm.getAttribute('data-ns-fav-remove')); syncAll(); return; }

    if (t.closest('[data-ns-fav-clear]')) { e.preventDefault(); clearAll(); syncAll(); return; }

    var atcBtn = t.closest('[data-ns-fav-atc]');
    if (atcBtn) { e.preventDefault(); addToCart(atcBtn.getAttribute('data-ns-fav-atc'), atcBtn); return; }

    var coBtn = t.closest('[data-ns-fav-checkout-all]');
    if (coBtn) { e.preventDefault(); addAllToCart(coBtn); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isDrawerOpen()) closeDrawer();
  });

  // Re-sync heart states when new cards are injected (AJAX recommendations,
  // recently-viewed, facet re-renders, editor reloads).
  var syncT = null;
  function scheduleSync() { clearTimeout(syncT); syncT = setTimeout(function () { syncButtons(); syncCount(); }, 60); }
  if (window.MutationObserver) {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var nodes = muts[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var nd = nodes[j];
          if (nd.nodeType !== 1) continue;
          if ((nd.matches && nd.matches('[data-ns-fav-btn]')) ||
              (nd.querySelector && nd.querySelector('[data-ns-fav-btn]'))) {
            scheduleSync();
            return;
          }
        }
      }
    });
    try { mo.observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  }

  function boot() { getCfg(); syncAll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* BACK FROM THE PAGE CACHE, THE LIST MAY HAVE CHANGED (audit, 23 Sep 2026).

     Safari — and Chrome on an iPhone — hands a page back alive, with this
     script's in-memory list exactly as it was when the shopper left. A heart
     tapped on the product page in between was saved to storage, but the
     `storage` event that would drop the cache is only sent to pages that are
     running, not to one frozen in the page cache. So the hearts and the count
     came back stale — and the next heart tapped here wrote the stale list
     back, deleting the favourite just saved on the product page. Re-read and
     repaint on the way back in. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    listCache = null;
    syncAll();
  });
  document.addEventListener('shopify:section:load', function () { cfg = null; syncAll(); });

  // Public hook for JS-rendered cards (recently-viewed) + the curate engine.
  window.NsFavorites = {
    sync: syncAll,
    // Straight from the cache, no copy: this is the per-card hot path and idxOf only reads.
    has: function (h) { return LS ? idxOf(cached(), h) >= 0 : false; },
    heartSvg: SVG_HEART,
    // Add a product to favourites from its card heart button (carries the data).
    addFromButton: function (btn) {
      if (!btn) return;
      var d = dataFromBtn(btn);
      if (idxOf(read(), d.handle) < 0 && add(d)) { syncAll(); announce(getCfg().addedToast); flashHeader(); }
    },
    remove: function (h) { remove(h); syncAll(); }
  };
})();
